import { Instagram, Facebook, Twitter, Youtube } from 'lucide-react';
import { SocialIcon } from './SocialIcon';
import { Copyright } from './Copyright';

export const Footer = () => {
  const socialLinks = [
    {
      href: 'https://www.instagram.com/bhaktisarovar/',
      icon: <Instagram size={24} />,
      label: 'Follow us on Instagram'
    },
    {
      href: 'https://www.facebook.com/bhaktisarovar/',
      icon: <Facebook size={24} />,
      label: 'Like us on Facebook'
    },
    {
      href: 'https://x.com/bhaktisarovar',
      icon: <Twitter size={24} />,
      label: 'Follow us on X (Twitter)'
    },
    {
      href: 'https://www.youtube.com/bhaktisarovar',
      icon: <Youtube size={24} />,
      label: 'Subscribe to our YouTube channel'
    }
  ];

  return (
    <footer className="w-full bg-white/10 backdrop-blur-sm mt-auto">
      <div className="max-w-4xl mx-auto px-4 py-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center space-x-6">
            {socialLinks.map((link) => (
              <SocialIcon
                key={link.href}
                href={link.href}
                icon={link.icon}
                label={link.label}
              />
            ))}
          </div>
          <Copyright />
        </div>
      </div>
    </footer>
  );
};